
import { convertCreditsFromServerToClient } from "../../../datastructures/Credits";
import { TournamentTexts } from "../../../datastructures/TournamentText";
import { truncateString } from "../../../functions/Functions_General";
import { Button } from "../../buttonsLibrary";
import { TournamentPlayer } from "../Interfaces_Tournament";
import { tournamenetLabelBox } from "./labelbox";
// import { PlayerActiveRank } from "./playerActiveRankDisplayer";


export class playerRank
{   
    private parent:PIXI.Container;
    private parentRanking:PIXI.Container;
    private parentRebuy:PIXI.Container;
    private placeHolderContainer:PIXI.Container;
    private bg:PIXI.Graphics;
    private bg_icon:PIXI.Graphics;
    private icon:PIXI.Sprite;
    // private title:PIXI.Text;
    private points:tournamenetLabelBox//PIXI.Text;
    private winnings:tournamenetLabelBox;

    private rebuyLayoutContainer:PIXI.Container;
    private rebuyInfoContainer:PIXI.Container;

    private placement:PIXI.Text;
    private totalParticipants:PIXI.Text;
    private lineSeparator:PIXI.Text;
    private titel:PIXI.Text;
    private portraitWidth:number;

    private landscapeheight:number;
    private landscapetWidth:number;
    private textStyleBig:PIXI.TextStyle;
    private infoTextStyle:PIXI.TextStyle;
    private rebuyTextStyle:PIXI.TextStyle;
    private infoBoxWin:PIXI.Text

    private rebuyHeader:PIXI.Text;
    private rebuyBtn:Button;
    private rebuyBtnSprite:PIXI.Sprite;
    private rebuyBtnLabel:PIXI.Text;
    private rebuyDescription:PIXI.Text;
    private rebuyPrice:PIXI.Text;
    private rebuysPossible:PIXI.Text;
    private rebuysLeft:PIXI.Text;
    private rebuysPossibleValue:PIXI.Text;
    private rebuysPriceValue:PIXI.Text;
    private rebuysLeftValue:PIXI.Text;

    private modeText:TournamentTexts;
    private badgeSprite:Array<PIXI.Texture>;

    // private prizeStyle:PIXI.TextStyle;
    private placeholderText:PIXI.Text;

    private isLandscpe:boolean;
    private enableRebuyBtn:boolean;
    private enableRebuyMode:boolean;
    // private playerPlacement:PlayerActiveRank;
    
    constructor(parent:PIXI.Container,fontStyle:PIXI.TextStyle,portraitWidth:number,height:number,tournamentText:TournamentTexts)
    {

        this.parent=new PIXI.Container();
        parent.addChild(this.parent);
        // parent
        this.isLandscpe=true;
        this.modeText=tournamentText;

        this.portraitWidth=portraitWidth;
        this.landscapetWidth=400;
        this.landscapeheight=height;

        this.textStyleBig= new PIXI.TextStyle({
            fontFamily:fontStyle.fontFamily,
            fontSize: 75,
            fill: '#ffffff',
            fontWeight:"bold",
            lineHeight : 120,
        
            align:'center',
            dropShadow: true,
            dropShadowColor: '#000000',
            dropShadowBlur: 2,
            dropShadowAngle: Math.PI / 6,
            dropShadowDistance: 0,
        
        });




   

        this.bg= new PIXI.Graphics()
        this.bg.beginFill(0x030914);
        //   this.bg.beginFill(0xff0000);
        this.bg.drawRoundedRect(0,0,this.landscapetWidth,this.landscapeheight,10);
        this.bg.endFill();
        this.parent.addChild(this.bg);
        this.bg.alpha=.95;

        this.enableRebuyBtn=false;
        this.enableRebuyMode=false;

        this.parentRanking=new PIXI.Container();
        this.parent.addChild(this.parentRanking);
        this.parentRebuy=new PIXI.Container();
       
            this.parent.addChild(this.parentRebuy);
        
  
        this.rebuyLayoutContainer=new PIXI.Container();
        this.parentRebuy.addChild(this.rebuyLayoutContainer);

        this.rebuyInfoContainer=new PIXI.Container();
        this.rebuyLayoutContainer.addChild(this.rebuyInfoContainer);

        

        this.placeHolderContainer=new PIXI.Container();
        this.parent.addChild(this.placeHolderContainer);

        this.bg_icon= new PIXI.Graphics()
        this.bg_icon.y=20;
        this.parentRanking.addChild(this.bg_icon);

        // this.icon=new PIXI.Sprite(PIXI.Texture.fromFrame('tournament_gold.png'));
        this.badgeSprite= [
            PIXI.Texture.fromFrame('tournament_badge_tier1.png'),
            PIXI.Texture.fromFrame('tournament_badge_tier2.png'),
            PIXI.Texture.fromFrame('tournament_badge_tier3.png'),
            PIXI.Texture.fromFrame('tournament_badge_tier4.png'),
            PIXI.Texture.fromFrame('tournament_badge_tier5.png'),
        ]
        this.icon=new PIXI.Sprite((this.badgeSprite[4]));//default last badge
        this.icon.anchor.set(.5);
        // this.icon.alpha=;
        // this.icon.scale.set(.3);
        this.icon.scale.set(.8);
        this.icon.position.set(200,200);
        this.bg_icon.addChild(this.icon);

        
 
        // this.playerPlacement= new PlayerActiveRank(this.parentRanking,fontStyle);
       

        this.placement=new PIXI.Text( ("---"),this.textStyleBig);
        this.placement.anchor.set(.5);
        this.placement.x=this.bg.width/2;
        this.placement.y=400;
        this.parentRanking.addChild(this.placement);



        this.lineSeparator=new PIXI.Text( ("______"),this.textStyleBig);
        this.lineSeparator.anchor.set(.5);
        this.lineSeparator.scale.set(.5);
        this.lineSeparator.y=15;
        // this.lineSeparator.rotation=Math.PI/180*-45;
        this.placement.addChild(this.lineSeparator);

        this.totalParticipants=new PIXI.Text( ("---"),this.textStyleBig);
        this.totalParticipants.anchor.set(.5);
        this.totalParticipants.scale.set(.65);
        this.totalParticipants.y=60;
        this.totalParticipants.alpha=.7;
        this.placement.addChild(this.totalParticipants);

        this.titel=new PIXI.Text( (this.modeText.YOURRANKING),fontStyle);
        this.titel.scale.set(.5)
        this.titel.anchor.set(.5);
        this.titel.x=this.bg.width/2;
        // this.titel.scale.set(.5);
        this.titel.y=this.titel.height;
        this.parent.addChild(this.titel);
        


      
        this.points=new tournamenetLabelBox(this.parentRanking,fontStyle,true,false);
        this.winnings=new tournamenetLabelBox(this.parentRanking,fontStyle,false,true);


        this.points.setlabel(tournamentText.TOTALPOINTS);        
        this.winnings.setlabel(tournamentText.RANKREWARD);

        this.winnings.setValue((0).toFixed(2)+ ' EUR');
        this.points.setValue((0).toFixed(2));



        // //--test
        // let fakeData=  {
        //     "position": 1,
        //     "displayName": "wardb",
        //     "score": 400,
        //     "prize": {
        //         "monetaryPrize": {
        //             "amount": 0,
        //             "currency": "EUR"
        //         },
        //         "nonMonetaryPrize": "PLAYSTATION FIVE1234567890123"
        //     }
        // }

        // this.setPlayerData(fakeData,11)
     
        this.parent.x=-this.landscapetWidth;
        this.infoTextStyle= new PIXI.TextStyle({
            fontFamily:fontStyle.fontFamily,
            fontSize: 25,
            fill: '#ffffff',
            fontWeight:"bold",
            lineHeight : 30,
            wordWrap:true,
            wordWrapWidth:(this.landscapetWidth),
        
            align:'center',
            dropShadow: true,
            dropShadowColor: '#000000',
            dropShadowBlur: 2,
            dropShadowAngle: Math.PI / 6,
            dropShadowDistance: 0,
        
        });

        this.rebuyTextStyle= new PIXI.TextStyle({
            fontFamily:fontStyle.fontFamily,
            fontSize: 25,
            fill: '#ffffff',
            // fontWeight:"bold",
            lineHeight : 30,
            wordWrap:true,
            wordWrapWidth:300,
        
            align:'center',
            dropShadow: true,
            dropShadowColor: '#000000',
            dropShadowBlur: 2,
            dropShadowAngle: Math.PI / 6,
            dropShadowDistance: 0,
        
        });
       
        this.infoBoxWin=new PIXI.Text(this.modeText.NOTE1,this.infoTextStyle );  
        this.parentRanking.addChild(this.infoBoxWin);
        this.placeholderText=new PIXI.Text(this.modeText.REWARDINFO,this.infoTextStyle );
        // this.placeholderText.anchor.set(.5);
        this.placeHolderContainer.addChild(this.placeholderText);
        this.placeHolderContainer.alpha=0;

        this.placeholderText.y=100;
        this.createRebuyElements();

        

        // let test=new tournamenetLabelBox(this.parent,fontStyle,true);
        // test.se;

        // let wins=(convertCreditsFromServerToClient(5000));
        // console.log(wins)
        // this.winnings.setValue(wins.toString(2)+' '+'EUR');


    }

    private setRebuyBtnActive=(bool:boolean):void=>
    {
        this.enableRebuyBtn=bool;
        if(this.enableRebuyBtn)
        {
            //---
            this.rebuyBtnSprite.tint=0xffffff;
            this.rebuyBtnLabel.tint=0xffffff;   
        }
        else
        {
            this.rebuyBtnSprite.tint=0x555555;
            this.rebuyBtnLabel.tint=0x555555;
       
        }
        this.rebuyBtn.setInteractive(bool);
    }
    private createRebuyElements=():void=>
    {   
        this.parentRebuy.scale.set(0);//make it only visible when needed , scale 0 to avoid having  placing issues when not visible

        // this.btn
        this.rebuyBtnSprite= new PIXI.Sprite(PIXI.Texture.fromFrame('tournament_btnSmall.png'));
        this.rebuyBtnSprite.anchor.set(.5);


   
     

        this.rebuyHeader= new PIXI.Text(this.modeText.REBUYS,this.textStyleBig);
        this.rebuyHeader.scale.set(.35)
        this.rebuyHeader.anchor.set(.5);
        this.rebuyHeader.y=10;
 
        if(this.rebuyHeader.width>this.landscapetWidth-10)
        {
            this.rebuyHeader.width=this.landscapetWidth-10;
            this.rebuyHeader.scale.set(this.rebuyHeader.scale.x)
        }
   
        this.rebuyBtn= new Button(this.rebuyBtnSprite,new PIXI.Rectangle(-190, -75, 380, 150));
  

        this.rebuyBtn.setFunction(this.updateRebuyData);

        this.rebuyBtnLabel= new PIXI.Text(this.modeText.REGISTER,this.textStyleBig);
        this.rebuyBtnLabel.scale.set(.5);
        this.rebuyBtnLabel.y=10
        this.rebuyBtnLabel.anchor.set(.5);
       

        this.rebuyDescription= new PIXI.Text(this.modeText.NOTE1,this.infoTextStyle);
        this.rebuyDescription.anchor.set(.5);
        this.parentRebuy.addChild(this.rebuyDescription);

        //labels
        this.rebuyPrice= new PIXI.Text(this.modeText.REBUYPRICE+':',this.rebuyTextStyle);
        // this.rebuyPrice.anchor.set(0,.5);
      

  
        this.rebuysPossible= new PIXI.Text(this.modeText.REBUYSPOSSIBLE+':',this.rebuyTextStyle);
        // this.rebuysPossible.anchor.set(0,.5);
  


        this.rebuysLeft= new PIXI.Text(this.modeText.REBUYSLEFT+':',this.rebuyTextStyle);
        // this.rebuysLeft.anchor.set(0,.5);
     
        this.rebuysLeft.style.align="left";

        //values
        this.rebuysPriceValue= new PIXI.Text('0.01 EUR',this.rebuyTextStyle);
        this.rebuysPriceValue.anchor.set(1,0);


        this.rebuysPossibleValue= new PIXI.Text('500',this.rebuyTextStyle);
        this.rebuysPossibleValue.anchor.set(1,0);


        this.rebuysLeftValue= new PIXI.Text('499',this.rebuyTextStyle);
        this.rebuysLeftValue.anchor.set(1,0);
   


        this.rebuysPriceValue.tint=0xff9900;
        this.rebuysLeftValue.tint=0xff9900;
        this.rebuysPossibleValue.tint=0xff9900;
        //-
        // this.infoBoxWin.text=" Bad game round? Try extra rounds with the rebuys below"
        if(this.enableRebuyMode)
        {     
            this.rebuyLayoutContainer.addChild(this.rebuyBtnSprite);
            this.rebuyInfoContainer.addChild( this.rebuyHeader)
            this.rebuyBtnSprite.addChild(this.rebuyBtnLabel);
            this.rebuyInfoContainer.addChild(this.rebuyPrice);    
            this.rebuyInfoContainer.addChild(this.rebuysPossible);
            this.rebuyInfoContainer.addChild(this.rebuysLeft);
            this.rebuyInfoContainer.addChild(this.rebuysPriceValue);
            this.rebuyInfoContainer.addChild(this.rebuysPossibleValue);
            this.rebuyInfoContainer.addChild(this.rebuysLeftValue);
        }
        this.setRebuyBtnActive(false)
      




    }

  
    public setPlayerData=(newData:TournamentPlayer,totalEntries:number):void=>
    {
        //old
        // let wins=(convertCreditsFromServerToClient(newData.prize.amount));
        // this.winnings.setValue(wins.toFixed(2)+' '+newData.prize.currency);
        //new
        let casWin=(convertCreditsFromServerToClient(newData.prize.monetaryPrize.amount));
        let nonCashWin=newData.prize.nonMonetaryPrize;
        if(nonCashWin!=undefined)
        {   
            if(newData.prize.monetaryPrize.amount>0)
            {
                this.winnings.setValue(casWin.toFixed(2)+' '+newData.prize.monetaryPrize.currency+'\n+ '+ truncateString(newData.prize.nonMonetaryPrize,23));
            }
            else
            {
                this.winnings.setValue( truncateString(newData.prize.nonMonetaryPrize,23));
            }
           
        }

        else
        {
            this.winnings.setValue(casWin.toFixed(2)+' '+newData.prize.monetaryPrize.currency);
        }
        



        this.placement.text= (newData.position).toString();
        this.totalParticipants.text=(totalEntries).toString();

        //update player badge
        let playerRank=newData.position;
        if(playerRank==1){this.icon.texture=this.badgeSprite[0]}
        else if(playerRank==2){this.icon.texture=this.badgeSprite[1]}
        else if(playerRank==3){this.icon.texture=this.badgeSprite[2]}
        else if(playerRank>3 && playerRank<11){this.icon.texture=this.badgeSprite[3]}
        else {this.icon.texture=this.badgeSprite[4]};//if no win  lastBadge

        this.setPlayerRankInLandscape(this.isLandscpe);

   
    }

    // public setRankOnly=(newPosition:number,totalEntries:number):void=>
    // {
        
    //     this.placement.text= (newPosition).toString();
    //     this.totalParticipants.text=(totalEntries).toString();

    //     //update player badge
    //     let playerRank=newPosition;
    //     if(playerRank==1){this.icon.texture=this.badgeSprite[0]}
    //     else if(playerRank==2){this.icon.texture=this.badgeSprite[1]}
    //     else if(playerRank==3){this.icon.texture=this.badgeSprite[2]}
    //     else if(playerRank>3 && playerRank<11){this.icon.texture=this.badgeSprite[3]}
    //     else {this.icon.texture=this.badgeSprite[4]};//if no win  lastBadge
        
    //     //-landscape fix

    //     if(this.isLandscpe)
    //     { 
    
    //         let offset=20
    //         this.placement.position.set(this.bg.width/2-this.placement.width/2+offset,400);
    //         this.totalParticipants.position.set(this.placement.width/2+this.totalParticipants.width/2+offset*2,0);
    //         this.lineSeparator.position.set(this.placement.width/2+offset/2,-10);
    //         this.lineSeparator.text="___"
    //         this.lineSeparator.rotation=Math.PI/180*-90;
    //     }
    //     else
    //     {
    //         this.placement.position.set(450,200);
    //         this.totalParticipants.position.set(0,60)
    //         this.lineSeparator.position.set(0,10);
    //         this.lineSeparator.text="______"
    //         this.lineSeparator.rotation=0;
        
    //     }

    // }
    // public testRank()
    // {
    //     let start=0
    //     setInterval(function () {start+=1; console.log(this),this.increment(start) }.bind(this), 10);
    // }
    // public  increment=(start:number):void=>
    // {   

    //     this.placement.text=start.toString();
    //     this.totalParticipants.text=start.toString();
    //     this.setPlayerRankInLandscape(this.isLandscpe);
    // }

    public setScore=(newScore:number):void=>
    {
        this.points.setValue(newScore.toFixed(2));
    }
   public setPortraitMode=():void=>
   {
  
    this.bg.width=this.portraitWidth;
    this.bg.height=this.landscapetWidth;
    this.parent.x=this.portraitWidth/2-this.bg.width/2;//-this.bg.width/2;
    this.parent.y=0;
    this.points.setPosition([this.bg.width-400,150]);
    this.winnings.setPosition([this.bg.width-400,250]);
    this.winnings.setLabelBGWidth(350);
    this.points.setLabelBGWidth(350);
    // 

    this.titel.x=this.bg.width/2;

    // this.placement.position.set(440,200);
    this.icon.position.set(180,200);


    // let offset=20
    // this.placement.position.set(450,200);
    // this.totalParticipants.position.set(0,60)
    // this.lineSeparator.position.set(0,10);
    // this.lineSeparator.text="______"
    // this.lineSeparator.rotation=0;

    this.setPlayerRankInLandscape(false);
    this.rebuyTextStyle.wordWrapWidth=400;
    //text box : rank  may change
    this.infoTextStyle.wordWrapWidth=this.portraitWidth-50;
    this.infoBoxWin.y=this.landscapetWidth-this.infoBoxWin.height;
    this.infoBoxWin.anchor.set(.5,0);
    this.infoBoxWin.x=this.portraitWidth/2;
 
      //rebuy
    let horizontalInfoSize=540
      this.rebuyBtnSprite.position.x=this.portraitWidth/2+280;
      this.rebuyBtnSprite.y=this.landscapetWidth-this.rebuyBtnSprite.height;

      this.rebuyDescription.x=this.portraitWidth/2;
      this.rebuyDescription.y=this.rebuyDescription.height+50;

      this.rebuyHeader.position.set(horizontalInfoSize/2,270-35)
    //   let offset=35;
      this.rebuyPrice.position.set(20,270);
      this.rebuysPossible.position.set(20, this.rebuyPrice.y+this.rebuyPrice.height+10);
      this.rebuysLeft.position.set(20,this.rebuysPossible.y+this.rebuysPossible.height+10);
     

      this.rebuysPriceValue.position.set(horizontalInfoSize,this.rebuyPrice.y+this.rebuyPrice.height/2-this.rebuysLeftValue.height/2);
      this.rebuysPossibleValue.position.set(horizontalInfoSize,this.rebuysPossible.y+this.rebuysPossible.height/2-this.rebuysPossibleValue.height/2);
      this.rebuysLeftValue.position.set(horizontalInfoSize,this.rebuysLeft.y+this.rebuysLeft.height/2-this.rebuysLeftValue.height/2);

  
      this.rebuyInfoContainer.y=this.rebuyBtnSprite.y-this.rebuyInfoContainer.height-120;
      this.placeholderText.x=this.portraitWidth/2-this.placeholderText.width/2;;
      this.placeholderText.y=100;
      this.isLandscpe=false;

   };

      public setLandscapeMode=():void=>
   {

    this.bg.width=this.landscapetWidth;
    this.bg.height=this.landscapeheight;
    this.parent.x=-this.landscapetWidth;

    this.points.setPosition([0,500]);    
    this.winnings.setPosition([0,600]);
// setLabelBGWidth

    this.points.setLabelBGWidth(350);
    this.winnings.setLabelBGWidth(350);

    this.titel.x=this.bg.width/2;
    this.placement.position.set(this.bg.width/2,430);
    this.icon.position.set(200,200);

   

    this.setPlayerRankInLandscape(true);

    //text box : rank  may change

    this.rebuyTextStyle.wordWrapWidth=300;
    this.infoTextStyle.wordWrapWidth=this.landscapetWidth-20;
    this.infoBoxWin.y=700;
    this.infoBoxWin.anchor.set(.5,0);
    this.infoBoxWin.x=this.landscapetWidth/2;

    //rebuy

    this.rebuyBtnSprite.x=this.landscapetWidth/2;
    this.rebuyBtnSprite.y=this.landscapeheight-this.rebuyBtnSprite.height;

    this.rebuyDescription.x=this.landscapetWidth/2;
    this.rebuyDescription.y=this.rebuyDescription.height;



    this.rebuyHeader.position.set(this.landscapetWidth/2,0)
    this.rebuyPrice.position.set(20,this.rebuyHeader.y+50);
    this.rebuysPossible.position.set(20,this.rebuyPrice.y+this.rebuyPrice.height+20);
    this.rebuysLeft.position.set(20,this.rebuysPossible.y+this.rebuysPossible.height+20);




    this.rebuysPriceValue.position.set(this.landscapetWidth-20,this.rebuyPrice.y+this.rebuyPrice.height/2-this.rebuysPriceValue.height/2);
    this.rebuysPossibleValue.position.set(this.landscapetWidth-20,this.rebuysPossible.y+this.rebuysPossible.height/2-this.rebuysPossibleValue.height/2);  
    this.rebuysLeftValue.position.set(this.landscapetWidth-20,this.rebuysLeft.y+this.rebuysLeft.height/2-this.rebuysLeftValue.height/2);

    this.rebuyBtnSprite.y=this.landscapeheight-this.rebuyBtnSprite.height;
    this.rebuyInfoContainer.y=this.rebuyBtnSprite.y-this.rebuyInfoContainer.height-50;
    
    // console.log('red')
    this.placeholderText.x=this.landscapetWidth/2-this.placeholderText.width/2;

    this.placeholderText.y=100;

    this.isLandscpe=true;
   };

   private updateRebuyData=():void=>
   {    
       console.log("CLICKED REBUY")
       this.rebuysLeftValue.text=Math.floor(Math.random()*360)+"";
       this.rebuysPossibleValue.text=Math.floor(Math.random()*360)+"";
       this.rebuysPriceValue.text=Math.floor(Math.random()*999)+".00 EUR";

       ///-----------DO REBUY REQUEST and on response 
       //--update the balance 
       //-reset the score of the game 
       //-enable play
        //disable the buy button
        
   }
   public setPostScreenMode=(posIndex:number):void=>
   {
    this.infoBoxWin.alpha=0;
    this.icon.scale.set(.8);
    this.bg.width=this.landscapetWidth;
    this.bg.height=this.landscapeheight;
    let xoffset=(this.portraitWidth-this.landscapetWidth*2)/2;
    // console.log(xoffset)
    this.parent.x=xoffset;
    this.titel.text=(this.modeText.YOURLASTRANK);
    if(posIndex==1)
    {
        this.parent.x=this.portraitWidth-this.landscapetWidth-xoffset;  
        this.titel.text=(this.modeText.YOURBESTRANK)

    }
    this.bg.alpha=0;
    this.bg.scale.set(1,0);
    this.points.setPosition([0,500]);    
    this.winnings.setPosition([0,600]);
// setLabelBGWidth

    this.points.setLabelBGWidth(350);
    this.winnings.setLabelBGWidth(350);

    this.titel.x=this.bg.width/2;
    // let offset=20
    // this.placement.position.set(this.bg.width/2-this.placement.width/2+offset,400);
    // this.totalParticipants.position.set(this.placement.width/2+this.totalParticipants.width/2+offset*2,0)
    // this.lineSeparator.position.set(this.placement.width/2+offset/2,-10);
    // this.lineSeparator.text="___"
    // this.lineSeparator.rotation=Math.PI/180*-90;
    this.setPlayerRankInLandscape(true);
    this.icon.position.set(200,200);
    this.isLandscpe=true;
   };

 
   private setPlayerRankInLandscape=(bool:boolean):void=>
   {
    if(bool)
    { 

        let offset=20
        this.placement.position.set(this.bg.width/2-this.placement.width/2+offset,400);
        this.totalParticipants.position.set(this.placement.width/2+this.totalParticipants.width/2+offset*2,0);
        this.lineSeparator.position.set(this.placement.width/2+offset/2,-10);
        this.lineSeparator.text="___"
        this.lineSeparator.rotation=Math.PI/180*-90;
    }
    else
    {
        this.placement.position.set(450,200);
        this.totalParticipants.position.set(0,60)
        this.lineSeparator.position.set(0,10);
        this.lineSeparator.text="______"
        this.lineSeparator.rotation=0;
    
    }
   }

   public setRebuyMode=(bool:boolean):void=>
   {    
    

       if(bool)
       {    //hide ranking and show rebuy
           this.parentRanking.alpha=0;
           this.titel.text='';//this.modeText.REBUYS;

         
           
            this.parentRebuy.alpha=1;//disable rebuy
            this.parentRebuy.scale.set(1);//disable rebuy
            if(this.enableRebuyBtn)
            {
                this.rebuyBtn.setInteractive(true);
            }
            
            this.titel.alpha=this.parentRebuy.scale.x;


            if(this.parentRebuy.alpha==0)
            {
                this.placeHolderContainer.alpha=1;
            }
            else
            {
                this.placeHolderContainer.alpha=0;
            }
           

       }
       else
       {    
            this.parentRanking.alpha=1;
            this.titel.text=this.modeText.YOURRANKING;
            this.titel.alpha=1;
            this.parentRebuy.alpha=0;
            this.parentRebuy.scale.set(0);
            this.rebuyBtn.setInteractive(false);

            if(  this.placeHolderContainer.alpha==1)
            {
                this.placeHolderContainer.alpha=0;
            }
       }
   }
//    public
}
